/**
 * 环境 → logo 映射:
 *   - hostname 含 `test`      → 绿色 (测试环境)
 *   - hostname 是 localhost/127.0.0.1 → 黄色 (本地/开发)
 *   - 其他                    → 原蓝色 (生产)
 *
 * 判定复用 JobTaskList/index.tsx 里已有的 hostname 规则,前端 build 时 test/prod
 * bundle 是同一份 (deploy/Jenkinsfile.test 走 `npm run build`),只能靠 runtime host 区分。
 */
import blueLogo from '@/assets/sim-logo.png';
import greenLogo from '@/assets/sim-logo-green.png';
import yellowLogo from '@/assets/sim-logo-yellow.png';

export type EnvKind = 'prod' | 'test' | 'dev';

export function detectEnv(): EnvKind {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'localhost' || host === '127.0.0.1') return 'dev';
  if (host.includes('test')) return 'test';
  return 'prod';
}

export function getEnvLogo(): string {
  switch (detectEnv()) {
    case 'test': return greenLogo;
    case 'dev':  return yellowLogo;
    default:     return blueLogo;
  }
}

// public/ 下同名文件,供 <link rel=icon> favicon 使用
export function getEnvFaviconHref(): string {
  switch (detectEnv()) {
    case 'test': return '/sim-logo-green.png';
    case 'dev':  return '/sim-logo-yellow.png';
    default:     return '/sim-logo.png';
  }
}
